import React, { useEffect, Profiler, useState } from 'react'
// import ReactPWAInstallProvider, { useReactPWAInstall } from "react-pwa-install";
import './Component-css/Downloadbutton.css?v=0.1'
// let deferredPrompt;
const Downloadbutton = () => {
  const [supportsPWA, setSupportsPWA] = useState(false)
  const [promptInstall, setPromptInstall] = useState(null)
  const [showDownloadPopup, setShowDownloadPopup] = useState(true);
  useEffect(() => {
    const handler = e => {
      e.preventDefault()
      console.log('we are being triggered :D')
      setSupportsPWA(true)
      setPromptInstall(e)
    }
    window.addEventListener('beforeinstallprompt', handler)

    return () => window.removeEventListener('transitionend', handler)
  }, [])

  const onClick = evt => {
    evt.preventDefault()
    if (!promptInstall) {

      return
    }
    promptInstall.prompt()
  }
  if (!supportsPWA) {
    return null
  }


  return (
    <>
      {/* // <div
    //   className='my-stickey-footer'
    //   style={{
    //     position: 'fixed',
    //     bottom: '57px',
    //     width: '100%',
    //     maxWidth: 480,
    //     backgroundColor: 'transparent',
    //     left: '0px'
    //   }}
    // >
    //   <div className='text-center' style={{ zoom: '1.2', padding: '10px 0px' }}>
    //     <button
    //       onClick={onClick}
    //       className='btn btn-sm text-white download_btn_bottom bounce-div'
    //       style={{ fontWeight: 500 }}
    //     >
          
    //       DOWNLOAD OUR APP
          
    //     </button>
    //   </div>
    // </div> */}

      {showDownloadPopup && (
        <div
          className="mlk_blue_download_overlay"
          onClick={() => setShowDownloadPopup(false)}
        >
          <div
            className="mlk_blue_download_popup"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="mlk_blue_handle"></div>

            <div className="mlk_popup_logo_wrap">
              <img src="../images/malik-ludo-logo1.png" className="mlk_popup_logo" alt="" />
            </div>

            <h3>Download Malik Ludo App</h3>

            <p>
              Play Faster • Better Performance • Instant Access
            </p>

            <div className="mlk_blue_btns">

              <button
                className="mlk_later_btn"
                onClick={() => {
                  localStorage.setItem("downloadPopupClosed", "true");
                  setShowDownloadPopup(false);
                }}
              >
                Later
              </button>

              <button
                className="mlk_download_now_btn"
                onClick={onClick}
              >

                <span className="mlk_download_icon">
                  ⬇
                </span>

                <span>
                  Download App
                </span>

              </button>

            </div>

          </div>
        </div>
      )}
    </>
  )
}

export default Downloadbutton
